import { useEffect, useState } from 'react';

// Single source of truth for "are we on a phone/tablet-width screen?".
// Matches the same 960px cutoff where the sidebar collapses into the
// hamburger menu (see theme.css), so the mobile experience is consistent:
// at this width the portal becomes view-only (except My Account and the
// Billing Tracker) and the big data lists turn into search boxes.
const MOBILE_QUERY = '(max-width: 960px)';

export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia(MOBILE_QUERY).matches
      : false,
  );

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mql = window.matchMedia(MOBILE_QUERY);
    const onChange = (e) => setIsMobile(e.matches);
    mql.addEventListener('change', onChange);
    // Sync once in case the width changed between initial state and effect.
    setIsMobile(mql.matches);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isMobile;
}
